module.exports = __webpack_public_path__ + "static/media/flowstacksvid.312e22f8.mp4";